import React from 'react';
import PrimaryButton from '../shared/PrimaryButton';
import SecondaryButton from '../shared/SecondaryButton';
import {
  PHONE_NUMBER,
  PHONE_NUMBER_LINK,
  PRIMARY_CTA_TEXT,
  SECONDARY_CTA_TEXT,
} from '../../data/contact';

const MobileStickyCTA = () => (
  <div className="mobile-sticky-cta" aria-label="Quick contact actions">
    <div className="mobile-sticky-cta-inner">
      <SecondaryButton
        href={PHONE_NUMBER_LINK}
        className="mobile-sticky-button"
        aria-label={`Call Now at ${PHONE_NUMBER}`}
      >
        {SECONDARY_CTA_TEXT}
      </SecondaryButton>
      <PrimaryButton to="/contact" className="mobile-sticky-button">
        {PRIMARY_CTA_TEXT}
      </PrimaryButton>
    </div>
  </div>
);

export default MobileStickyCTA;
